import { Controller } from "@hotwired/stimulus"

// Generic live-search: submits the host form as the user types (debounced),
// so results update via Turbo Stream without losing input focus. Covers typing,
// editing and clearing with a single path. Optionally prevents Enter from
// firing a redundant submit. Reusable on any auto-submitting search form.
export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue)
  }

  // Live search already submits on input; Enter would fire a redundant submit.
  preventEnter(event) {
    event.preventDefault()
  }

  disconnect() {
    clearTimeout(this.timeout)
  }
}
